import styled from 'styled-components';

const Portfolio = styled.div`
  z-index: 100 !important;
  width: 100%;
`;

const Espacio = styled.div`
  min-height: 100vh;
  background: white;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  Portfolio,
  Espacio
}